import { Certificate } from '@/entities/certificate';
import { http } from '@/http';
import { VisibleSignatureOptions } from './sign-uploaded-document';

type SignZIPResponse = {
	success: boolean;
	batchUlid: string;
	total: number;
	succeeded: number;
	failed: number;
	skipped: number;
	results: {
		filename: string;
		success: boolean;
		skipped: boolean;
		signedPath: string;
	}[];
	signedZipUrl: string;
};

export async function signZIP(
	zipFile: File,
	certificateId: Certificate['certificate_id'],
	otp: {
		type: 'sms' | 'pin';
		value: string;
	},
	annotationOptions?: Pick<
		VisibleSignatureOptions,
		| 'page_number'
		| 'position_x'
		| 'position_y'
		| 'width'
		| 'height'
		| 'motive'
	>,
) {
	const metadata: Record<string, unknown> = {
		certificate_id: certificateId,
		otp: { type: otp.type, value: otp.value },
	};
	if (annotationOptions)
		metadata.visible_signature_options = annotationOptions;

	const signZipResposne = await http.post<SignZIPResponse>(
		'documents/sign-batch',
		{
			file: zipFile,
			metadata: JSON.stringify(metadata),
		},
	);
	return signZipResposne;
}
